// Thin axios wrappers around the engine-monitoring CP endpoints.
// All three routes live under `/api/admin/engines/...`, which is the
// base URL configured on adminAxios.

import api from "../utils/axios/v1/adminAxios";

export const getEngineCluster = (type) =>
  api.get(`/engines/cluster/${encodeURIComponent(type)}`);

export const getEngineClusterSummary = (type) =>
  api.get(`/engines/cluster/${encodeURIComponent(type)}/summary`);

export const getEngineTimeseries = (id, { range = "1h", metrics } = {}) => {
  const params = { range };
  if (metrics) params.metrics = metrics;
  return api.get(`/engines/${encodeURIComponent(id)}/timeseries`, { params });
};

const engineMonitoringService = {
  getEngineCluster,
  getEngineClusterSummary,
  getEngineTimeseries,
};

export default engineMonitoringService;
